import apiClient from '../apiClient';
import { POST_SET_PRIMARY_IMAGE_ACCOMODATION_PROFILE_URL } from '../apiUrl';

const postSetPrimaryImageAccomodationProfileApi = id => {
  return apiClient.post(POST_SET_PRIMARY_IMAGE_ACCOMODATION_PROFILE_URL(id));
};

export default postSetPrimaryImageAccomodationProfileApi;
